import { useFeatureFlag } from 'configcat-react';

import { LOYALTY_INCENTIVE_CAMPAIGN } from 'core';

export const useHeaderContent = () => {
  useFeatureFlag(LOYALTY_INCENTIVE_CAMPAIGN, false);
};
